import { useCallback, useEffect, useState } from "react";
import { fleetStatus, fleetSetModels, fleetHealth, fleetShadow } from "@/lib/rootConsole";

const card = { background: "#121924", border: "1px solid #22303f", borderRadius: 10, padding: 16, marginBottom: 16 };
const btn = { background: "#1f6feb", color: "#fff", border: "none", borderRadius: 8, padding: "8px 14px", cursor: "pointer", marginRight: 8, marginTop: 8 };
const ghost = { ...btn, background: "#30363d" };
const input = { background: "#0b0f14", color: "#d7e0ea", border: "1px solid #22303f", borderRadius: 8, padding: 10, width: "100%", marginTop: 8, fontFamily: "inherit" };
const STATE_COLOR = { HEALTHY: "#7ee787", DEGRADED: "#e3b341", DOWN: "#ff7b72", RECOVERING: "#58a6ff", NOT_CONFIGURED: "#8b98a5" };

// A1 — Flotte IA TYLUSS : Infomaniak multi-modèles + Champion/fallbacks/secours local + SHADOW.
export default function FleetPanel() {
  const [fleet, setFleet] = useState(null);
  const [err, setErr] = useState(null);
  const [busy, setBusy] = useState(false);
  const [models, setModels] = useState("");

  const load = useCallback(async () => {
    try { const d = await fleetStatus(); setFleet(d.fleet); setErr(null);
      setModels((d.fleet?.models || []).filter((m) => !m.local).map((m) => m.model_id).join(", "));
    } catch (e) { setErr(e?.response?.data?.detail || "Connectez-vous en Founder."); }
  }, []);
  useEffect(() => { load(); }, [load]);

  const run = async (fn) => { setBusy(true); setErr(null); try { const d = await fn(); setFleet(d.fleet || d.shadow ? (d.fleet || fleet) : fleet); await load(); } catch (e) { setErr(e?.response?.data?.detail || String(e)); } finally { setBusy(false); } };
  const save = () => run(() => fleetSetModels(models.split(",").map((s) => s.trim()).filter(Boolean)));

  return (
    <div style={card} data-testid="root-ai-fleet">
      <h3 style={{ color: "#58a6ff", marginTop: 0 }}>Flotte IA TYLUSS · Infomaniak + failover</h3>
      <div style={{ color: "#8b98a5", fontSize: 12, marginBottom: 8 }}>
        Champion + fallbacks + secours local. La clé et l&apos;endpoint viennent de l&apos;infra
        (INFOMANIAK_AI_BASE_URL / INFOMANIAK_AI_API_KEY) — jamais saisis ici, jamais exposés.
        Sans credentials → NOT_CONFIGURED (aucune fausse IA).
      </div>
      {err && <div style={{ ...card, borderColor: "#f85149", color: "#ff7b72", marginBottom: 10 }} data-testid="fleet-error">{err}</div>}

      {fleet && (
        <div data-testid="fleet-status" style={{ fontSize: 13, marginBottom: 8 }}>
          <div>Champion : <b style={{ color: "#7ee787" }}>{fleet.champion || "—"}</b> · {fleet.remote_count} distant(s) · {fleet.local_fallback_count} secours local · <b style={{ color: fleet.configured ? "#7ee787" : "#ff7b72" }}>{fleet.configured ? "CONFIGURÉ" : "NON CONFIGURÉ"}</b></div>
          <div style={{ marginTop: 8 }}>
            {(fleet.models || []).map((m) => (
              <div key={m.model_id} data-testid={`fleet-model-${m.model_id}`} style={{ display: "flex", justifyContent: "space-between", padding: "4px 0", borderBottom: "1px solid #1a2430" }}>
                <span>{m.local ? "🖥️ " : "☁️ "}{m.label} <span style={{ color: "#8b98a5" }}>{m.api_key_set ? "· clé ✓" : ""}</span></span>
                <span style={{ color: STATE_COLOR[m.state] || "#8b98a5", fontWeight: 700 }}>{m.state}{m.last_latency_ms != null ? ` · ${m.last_latency_ms}ms` : ""}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      <span style={{ color: "#8b98a5", fontSize: 12 }}>model_id Infomaniak (CSV, 1er = Champion) :</span>
      <input style={input} value={models} onChange={(e) => setModels(e.target.value)} placeholder="llama-3.3-70b, mixtral-8x22b, ..." data-testid="fleet-input-models" />
      <div>
        <button style={btn} onClick={save} disabled={busy} data-testid="fleet-save">Enregistrer les modèles</button>
        <button style={ghost} onClick={() => run(fleetHealth)} disabled={busy} data-testid="fleet-health">Health check</button>
        <button style={ghost} onClick={() => run(fleetShadow)} disabled={busy} data-testid="fleet-shadow">SHADOW (recovering)</button>
      </div>
      {busy && <div style={{ color: "#8b98a5", marginTop: 10, fontSize: 13 }}>Traitement…</div>}
    </div>
  );
}
